import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import React, { useState } from "react";
import { AiFillYoutube, AiOutlineInstagram } from "react-icons/ai";
import { FaDiscord } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { STORAGE_URL } from "../constants";
import { Logo } from "../staticData/images";
import WalletConnectButton from "./Wallet/WalletConnectButton";

const MobileHeaderRoot = styled("div")({
  // flexGrow: 1,
});

const DrawerContent = styled("div")({
  position: "sticky",
  top: "0",
  backgroundColor: "black",
  color: "white",
  width: 250,
});
const MobileHeader = ({ isHome = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const NAVITEM = [
    { name: "About Us", link: "/about" },
    { name: "Contact", link: "/contactUs" },
  ];

  const handleSidebarOpen = () => {
    setSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const [drawerOpen, setDrawerOpen] = useState(false);
  const redirectToHome = () => {
    navigate("/");
  };
  const goBack = () => {
    navigate(-1);
  };
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  const NavItem = ({ to, name, onClick }) => {
    return (
      <NavLink
        to={to}
        style={{
          textDecoration: "none",
          color: "inherit",
        }}
        onClick={onClick}
      >
        <ListItem button>
          <ListItemText
            style={{
              fontFamily: "var(--font-g)",
            }}
            primary={name}
          />
        </ListItem>
      </NavLink>
    );
  };
  const socialIcons = [
    {
      icon: <AiFillYoutube />,
      link: "https://www.youtube.com/@YugaLabs",
    },

    {
      icon: <AiOutlineInstagram />,
      link: "https://www.instagram.com/yugalabs",
    },
    {
      icon: <FaDiscord />,
      link: "https://discord.com/invite/3P5K3dzgdB",
    },
    {
      icon: <FaXTwitter />,
      link: "https://x.com/yugalabs",
    },
  ];
  const AppBarStyled = styled(AppBar)({
    // position: "sticky",
    // top: 0,
    backgroundColor: "transparent",
    height: "100px",
  });
  return (
    <MobileHeaderRoot sx={{ boxShadow: "none" }}>
      <AppBarStyled sx={{ boxShadow: "none" }} position="sticky">
        <Toolbar
          sx={{
            boxShadow: "none",
            width: "100vw",
            justifyContent: "space-between",
          }}
        >
          {location.pathname !== "/" && (
            <img
              src={STORAGE_URL + "yuga/icons/backIcon.svg"}
              // height="46px"
              width="auto"
              onClick={goBack}
              style={{
                paddingRight: "5px",
              }}
            />
          )}

          <Typography
            variant="h6"
            component="div"
            // sx={{ flexGrow: 1 }}
            onClick={redirectToHome}
          >
            <img src={Logo} height="20px" width="auto" />
          </Typography>
          <Box
            display="flex"
            sx={{
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <IconButton color="inherit" onClick={() => toggleDrawer()}>
              <MenuIcon
                sx={{
                  cursor: "var(--pointer-cursor)",
                  marginBottom: "5px",
                }}
              />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBarStyled>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer}
        sx={{ width: 300 }}
      >
        <DrawerContent sx={{ backgroundColor: "black", height: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              p: 2,
            }}
          >
            <IoCloseSharp
              onClick={toggleDrawer}
              style={{ cursor: "var(--pointer-cursor)" }}
              size={30}
              color="#fff"
            />
          </Box>
          <List sx={{ mt: 5 }}>
            {NAVITEM.map((item, index) => (
              <NavItem
                key={index}
                to={item.link}
                name={item.name}
                onClick={toggleDrawer}
              />
            ))}
          </List>
          <Box sx={{ ml: 1 }}>
            <WalletConnectButton height={"40px"} />
          </Box>
          <>
            <Divider
              sx={{
                marginTop: "6vw",
                border: "1px solid #E3DFD6",
              }}
            />
            <Box
              sx={{
                marginLeft: "3vw",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "var(--font-g)",
                  fontSize: "18px",
                  fontWeight: "700",
                  marginBlock: "16px",
                }}
              >
                Follow Us
              </Typography>
              <Box
                display="flex"
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {socialIcons.map(({ icon, boxShadow, link }, index) => (
                  <Box
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      cursor: "var(--pointer-cursor)",
                      alignItems: "center",
                      marginRight: index < socialIcons.length - 1 ? "2vw" : 0,
                      fontSize: "18px",
                    }}
                    onClick={() => window.open(link, "_blank")}
                    width="44px"
                  >
                    {icon}
                  </Box>
                ))}
              </Box>
            </Box>
          </>
        </DrawerContent>
      </Drawer>
    </MobileHeaderRoot>
  );
};

export default MobileHeader;
